import { onUnmounted } from "vue";
import { AxiosError } from "axios";
import { store } from "@/shared-store";
import heartBeatCart from "@/apps/merchant3/services/heartbeat.service";
import { IVuexState } from "@/apps/merchant3/shared-models/IVuex";
import { Store } from "vuex";

export default function useHeartBeatCart(): void {
  const vuexStore = store as unknown as Store<IVuexState>;
  if (!vuexStore.state.carts?.cartTag) {
    if (sessionStorage.getItem("PJ_cartTag")) {
      store.dispatch("carts/setCartTag", sessionStorage.getItem("PJ_cartTag"));
    }
  }
  const interval: ReturnType<typeof setInterval> = setInterval(() => {
    const cartTag = vuexStore.state.carts?.cartTag;
    if (!cartTag) {
      clearInterval(interval);
      return;
    }
    heartBeatCart(cartTag).then(
      () => {
        // should we set lastActive in customer?
      },
      (error: AxiosError) => {
        console.log("heartBeatCart Error", error);
        if (error.response?.status === 403) {
          clearInterval(interval);
        }
      }
    );
  }, 30 * 1000);

  onUnmounted(() => {
    clearInterval(interval);
  });
}
